// extracted by mini-css-extract-plugin
module.exports = {"main":"CrossableTag_main__IAmbW","cross_icon":"CrossableTag_cross_icon__2-Tx1","tag_name":"CrossableTag_tag_name__yPLmL"};